export default __webpack_public_path__ + "static/media/addIcon.208c6d7e.webp";